/*eslint-disable*/
import React from "react";
import Image from "next/image"
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import Camera from "@mui/icons-material/Camera";
import Palette from "@mui/icons-material/Palette";

// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Parallax from "components/Parallax/Parallax.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";

import styles from "pages-sections/services/ServicesSections.module.scss";


export default function ProfilePage({ ...rest }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
  return (
    <div>
    <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        title="Victoria Prodromidis - Tribalism"
        image="/img/examples/city-sm.webp"
        url="https://www.tribalism.com.au/about/profile-victoria-prodromidis"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Meet Victoria, Tribalism's Marketing Executive !"

        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "info",
        }}
      />

      <Parallax
        image="/img/examples/city-sm.webp"
        filter="dark"
        className={classes.parallax}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={6}>
              <div className={classes.profile}>
                <div>
                  <img
                    src="/img/faces/Victoria-sq.webp"
                    alt="..."
                    className={imageClasses}
                  />
                </div>
                <div className={classes.name}>
                  <h3 className={classes.title}>Victoria Prodromidis</h3>
                  <h6>MARKETING CONSULTANT</h6>
      
                  <a href = "https://www.linkedin.com/in/victoria-prodromidis-109928126/" target="_blank">
                  <Button
                    justIcon
                    simple
                    color="linkedin"
                    
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-linkedin"} />
                  </Button>
                  </a>

                  <a href = "https://github.com/Victoria-Tribalism"  target="_blank">
                  <Button
                    justIcon
                    simple
                    color="github"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-github"} />
                  </Button>
                  </a>
                </div>
              </div>

            </GridItem>
          </GridContainer>
          <div className={classNames(classes.description, classes.textCenter)}>
            <p>
              You can call me Vic :) I love summer and the beach, pasta and spritz, fashion and art, dancing/working out and travelling the world! I come from a Marketing/Management & Innovation background and enjoy working on clients social media pages, websites and creating different types of advertisements!
              <br /> I specialise in SEO/SEM and landing page optimisation and am pretty confident I can get your website ranking in the top 10! I am super creative, so you should come to me for all things marketing and content creation, especially for AdWords, Facebook, LinkedIn & Instagram Campaigns.
            </p>
          </div>
          <div className={classes.profileTabs}>
            <NavPills
              alignCenter
              color="warning"
              tabs={[
                {
                  tabButton: "Work",
                  tabIcon: Palette,
                  tabContent: (
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={7}
                        className={classes.gridItem}
                      >
                        <h4 className={classes.title}>Latest Blog Posts</h4>
                        <GridContainer className={classes.collections}>
                          <GridItem xs={12} sm={12} md={6}>
                          <Card
                            raised
                            background
                            style={{ backgroundImage: "url('/img/posts/2021-06-30-linkedin/blog-image-one.jpg')" }}
                          >
                            <CardBody background>
                              <h6 className={classes.category}>Other</h6>
                              <a href="/blog-post/2021/06/has-your-linkedin-campaign-been-rejected">
                                <h3 className={classes.cardTitle}>
                                Has Your LinkedIn Campaign Been Rejected? (June 2021)
                                </h3>
                              </a>

                              <Button round href="/blog-post/2021/06/has-your-linkedin-campaign-been-rejected" color="warning">
                                <FormatAlignLeft className={classes.icons} /> Read article
                              </Button>
                            </CardBody>
                          </Card>

                          </GridItem>
                          
                        </GridContainer>
                      </GridItem>
                      
                    </GridContainer>
                  ),
                },
                
                {
                  tabButton: "Media",
                  tabIcon: Camera,
                  tabContent: (
                    <GridContainer justifyContent="center">
                      <GridItem xs={12} sm={12} md={3}>
                        <div className={navImageClasses} > 
                        <Image
                          layout = "responsive"
                          width = {255}
                          height = {170}

                          alt="..."
                          src="/img/photo-gallery/pg4-sm.webp"
                          
                        />
                        </div>
                    
                        
                      </GridItem>
                    </GridContainer>
                  ),
                },
              ]}
            />
          </div>
          <Clearfix />
        </div>
      </div>
      <Footer
        
      />
    </div>
  );
}
